export const initialState = {
  gender: '',
  categories: [],
  brands: [],
  colors: [],
  price: [],
  ratings: [],
};

export const genderData = [
  {
    id: 1,
    name: 'Men',
    slug: 'men',
  },
  {
    id: 2,
    name: 'Women',
    slug: 'women',
  },
  {
    id: 3,
    name: 'Kids',
    slug: 'kids',
  },
  {
    id: 4,
    name: 'Boys',
    slug: 'boys',
  },
  {
    id: 5,
    name: 'Girls',
    slug: 'girls',
  },
];

export const categoriesData = [
  {
    id: 1,
    name: 'T-Shirts',
    count: 150,
  },
  {
    id: 2,
    name: 'Shirts',
    count: 49,
  },
  {
    id: 3,
    name: 'Trousers',
    count: 220,
  },
  {
    id: 4,
    name: 'Jackets',
    count: 99,
  },
  {
    id: 5,
    name: 'Wallets',
    count: 6,
  },
  {
    id: 6,
    name: 'Shoes',
    count: 501,
  },
  {
    id: 7,
    name: 'Sandals',
    count: 88,
  },
];

export const brandsData = [
  {
    id: 1,
    name: 'Shovia',
    count: 108,
  },
  {
    id: 2,
    name: 'Fusion',
    count: 49,
  },
  {
    id: 3,
    name: 'Hunter Shoes',
    count: 320,
  },
  {
    id: 4,
    name: 'Club Shoes',
    count: 19,
  },
  {
    id: 5,
    name: 'Hoppister',
    count: 16,
  },
  {
    id: 6,
    name: 'Blaze Fashion',
    count: 350,
  },
  {
    id: 7,
    name: 'Elegance',
    count: 88,
  },
  {
    id: 7,
    name: 'Fashadil',
    count: 201,
  },
];

export const colorsData = [
  {
    id: 1,
    name: 'Black',
    color: '#000000',
    count: 88,
  },
  {
    id: 2,
    name: 'Red',
    color: '#D34B56',
    count: 150,
  },
  {
    id: 3,
    name: 'Green',
    color: '#5EB160',
    count: 210,
  },
  {
    id: 4,
    name: 'Blue',
    color: '#0074D9',
    count: 12,
  },
  {
    id: 5,
    name: 'Gold',
    color: '#E5C74A',
    count: 320,
  },
  {
    id: 6,
    name: 'Purple',
    color: '#800080',
    count: 62,
  },
  {
    id: 7,
    name: 'Lime Green',
    color: '#5DB653',
    count: 55,
  },
];

export const ratingData = [
  {
    id: 1,
    products: 55,
  },
  {
    id: 2,
    products: 250,
  },
  {
    id: 3,
    products: 75,
  },
  {
    id: 4,
    products: 120,
  },
  {
    id: 5,
    products: 70,
  },
];
